// A product with StockRequis = false can be ordered whatever its stock,
// and the shop never shows its stock. Missing flag (older data) = stock required.
export const isStockRequired = (product) =>
  (product?.stockRequis ?? product?.StockRequis) !== false;

// Quantity cap when stock does not limit the order
export const UNLIMITED_ORDER_QUANTITY = 99;
